import type { State } from '~/store';

export function selectThresholdSimParamsByPublicId(thresholdPublicId: string) {
  return function selector(state: State) {
    const thresholdSimInstance = state.thresholdSimulator[thresholdPublicId];
    if (thresholdSimInstance) {
      return thresholdSimInstance.params;
    }
    return undefined;
  };
}
